import oRequest from '@/libsV2/request.js';

const URL = {
    FREE_PUSH: 'topic/free/push', //免费设计提交
}
//交付评价星级对应标签
export default {
    freePush(data = {}){
        let oData = Object.assign({},data);
        return oRequest.getData(URL.FREE_PUSH,oData)
    },
}
